import React from 'react';
import LoadingScreen from 'features/LoadingScreen'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faCheck} from '@fortawesome/free-solid-svg-icons'
import {faTimes} from '@fortawesome/free-solid-svg-icons' 
import {Trans} from 'react-i18next'
import {checkAndGetLocalStorageValue} from "../../../features/utils";
import i18next from 'i18next';

export default ({ state, history, nextStepName= 'Care Service' }) =>{
    state.triageRequest.activeMenu = "care-options"
    var selectPharmacyText=i18next.t("findcareoption.Careoptions.telemedicine.pharmaprompt")+i18next.t("findcareoption.Careoptions.telemedicine.pharmaprompt1")+i18next.t("findcareoption.Careoptions.telemedicine.pharmaprompt2")
  return(

    <LoadingScreen isLoading={state.isLoading}>
        <div class="row pharmacy-prompt-container">
           <div class="col-12 col-lg-3 col-md-2 col-sm-1"> </div>
           <div class="content-width mt-3">
                <div class="standby-page-header standby-page-header-left">
                    <h1 class="standby-page-header-title"><Trans i18nKey="findcareoption.Careoptions.telemedicine.justonemorething">Pharmacy Selection Requied</Trans></h1>
                </div>

                <p class="row w-form-label-justify">
                <Trans i18nKey="findcareoption.Careoptions.telemedicine.pharmaprompt0">Before your consultation, you </Trans>
                <span className="mustbold"><Trans i18nKey="findcareoption.Careoptions.telemedicine.pharmapromptmust">must </Trans></span>
                <Trans i18nKey="findcareoption.Careoptions.telemedicine.pharmaprompt2">select a nearby pharmacy to ensure prescriptions can be processed if needed. This step is mandatory to proceed.</Trans>
                </p>
                <p className="mustbold"> <Trans i18nKey="findcareoption.Careoptions.telemedicine.selectPharmatoContinue">Please select a pharmacy to continue.</Trans></p>
                <div class="pharmacy-prompt row">
                    <div class="mt-2  line-length">
                        <button class="button standby-button standby-button-gradient standby-button-full-width standby-button-gradient-green"
                            onClick={e => {
                            nextStepName="care-options-result"
                            state.triageRequest.ispharmaselected = true
                            gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
                            history.push(`/find-care-options/${nextStepName}`)
                            }}
                            aria-label={selectPharmacyText + " " + i18next.t("findcareoption.Yes")}>
                            {/* <div class="icon icon-size-3"><FontAwesomeIcon style={{color:"green",fontSize:"25px"}}  icon={faCheck} /></div> */}
                            <div><Trans i18nKey="findcareoption.Careoptions.telemedicine.selectPharmacy">Select Pharmacy</Trans></div>
                        </button>
                    </div>

                    {/* <div class="col-6 text-left pharmacy-prompt-item">
                        <button type="button" class="button pharmacy-prompt pharmacy-prompt-no"
                        onClick={e => { 
                            state.triageRequest.activeMenu = "care-options";
                            if(state.isTravelAid2){
                                nextStepName="done"
                            }else{
                            nextStepName="patientdetails-confo-screen"}
                            gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
                            history.push(`/find-care-options/${nextStepName}`)
                            }}
                            aria-label={selectPharmacyText + " " + i18next.t("findcareoption.No")}>
                            <div class="icon icon-size-2"><FontAwesomeIcon style={{color:"red",fontSize:"25px"}}  icon={faTimes} /></div>
                           <div><Trans i18nKey="findcareoption.No" >No</Trans></div> 
                        </button>
                    </div> */}
                </div>
            </div>
            <div class="col-12 col-lg-3 col-md-2 col-sm-1"> </div>
        </div>

    </LoadingScreen>
)
}